// Capture l'événement d'installation PWA dès le chargement (avant que React ne monte).
let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn(true));
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    try { localStorage.setItem('obgh_app_installed', '1'); } catch { /* ignore */ }
    listeners.forEach((fn) => fn(false));
  });
}

export const canPromptInstall = () => !!deferredPrompt;
export const onInstallPromptChange = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };

export const promptInstall = async () => {
  if (!deferredPrompt) return 'unavailable';
  const p = deferredPrompt;
  deferredPrompt = null;
  p.prompt();
  const { outcome } = await p.userChoice;
  return outcome; // 'accepted' | 'dismissed'
};

export const isStandalone = () =>
  (typeof window !== 'undefined' && window.matchMedia?.('(display-mode: standalone)').matches) ||
  (typeof navigator !== 'undefined' && navigator.standalone === true);

export const isIOS = () =>
  typeof navigator !== 'undefined' && /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;

export const isMobileDevice = () =>
  typeof navigator !== 'undefined' && /android|iphone|ipad|ipod|mobile/i.test(navigator.userAgent);
